import React from "react";
import "./ModernGauge.css";

const ModernGauge = ({ value, min = -90, max = 90 }) => {
  
  const showNeedle = ( value >= min && value <= max)

  const clamped = Math.min(Math.max(value, min), max);
  const range = max - min;

  const angle = ((clamped - min) / range) * 180; // 0..180
  const svgAngle = 180 + angle; // 180..360
  const angleRad = (Math.PI * svgAngle) / 180;

  const length = 90; // pidempi neula
  const widthBase = 6;

  const tipX = 100 + length * Math.cos(angleRad);
  const tipY = 100 + length * Math.sin(angleRad);

  const sideX = (widthBase / 2) * Math.sin(angleRad);
  const sideY = (widthBase / 2) * Math.cos(angleRad);

  const baseLeftX = 100 - sideX;
  const baseLeftY = 100 + sideY;

  const baseRightX = 100 + sideX;
  const baseRightY = 100 - sideY;

  const pathData = `
    M ${baseLeftX} ${baseLeftY}
    L ${tipX} ${tipY}
    L ${baseRightX} ${baseRightY}
    Z
  `;

  // Asteikon viivat joka 30 astetta (-90, -60, -30, 0, 30, 60, 90)
  /*
  const ticks = [];
  for (let deg = min; deg <= max; deg += 30) {
    const tAngle = ((deg - min) / range) * 180 + 180;
    const tRad = (Math.PI * tAngle) / 180;
    const innerRadius = 72;
    const outerRadius = 86;

    const x1 = 100 + innerRadius * Math.cos(tRad);
    const y1 = 100 + innerRadius * Math.sin(tRad);
    const x2 = 100 + outerRadius * Math.cos(tRad);
    const y2 = 100 + outerRadius * Math.sin(tRad);

    const labelRadius = 105;
    const lx = 100 + labelRadius * Math.cos(tRad);
    const ly = 100 + labelRadius * Math.sin(tRad);

    ticks.push(
      <g key={deg}>
        <line
          x1={x1}
          y1={y1}
          x2={x2}
          y2={y2}
          stroke="#333"
          strokeWidth={1}
          strokeLinecap="round"
        />
        <text
          x={lx}
          y={ly + 5}
          fontSize="14"
          fontWeight="600"
          fill="#222"
          textAnchor="middle"
          alignmentBaseline="middle"
        >
          {deg}
        </text>
      </g>
    );
  }
    */

const ticks = [];
  for (let deg = min; deg <= max; deg += 1) {
    const tAngle = ((deg - min) / range) * 180 + 180;
    const tRad = (Math.PI * tAngle) / 180;
    const innerRadius = 72;
    const outerRadius = 88;

    const x1 = 100 + innerRadius * Math.cos(tRad);
    const y1 = 100 + innerRadius * Math.sin(tRad);
    const x2 = 100 + outerRadius * Math.cos(tRad);
    const y2 = 100 + outerRadius * Math.sin(tRad);

    const labelRadius = 105;
    const lx = 100 + labelRadius * Math.cos(tRad);
    const ly = 100 + labelRadius * Math.sin(tRad);

    ticks.push(
      <g key={deg}>
        <line
          x1={x1}
          y1={y1}
          x2={x2}
          y2={y2}
          stroke="#333"
          strokeWidth={1}
          strokeLinecap="round"
        />
        <text
          x={lx}
          y={ly + 5}
          fontSize="14"
          fontWeight="600"
          fill="#222"
          textAnchor="middle"
          alignmentBaseline="middle"
        >
          {deg}
        </text>
      </g>
    );
  }

  return (
    <div className="gauge-container">
      <svg
        className="gauge-svg"
        viewBox="-10 -10 230 140"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient
            id="arcGradient"
            x1="0"
            y1="100"
            x2="200"
            y2="100"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0%" stopColor="#fc7c51" />
            <stop offset="20%" stopColor="#fceb51" />
            <stop offset="50%" stopColor="#9efc51" />
            <stop offset="80%" stopColor="#fceb51" />
            <stop offset="100%" stopColor="#fc7c51" />
          </linearGradient>
        </defs>

        {/* Liukuvärinen taustakaari */}
        <path
          d="M 20 100 A 80 80 0 0 1 180 100"
          fill="none"
          stroke="url(#arcGradient)"
          strokeWidth="20"
          strokeLinecap="round"
        />

        {/* Asteikon viivat ja numerot */}
        {ticks}

        { showNeedle && (
            <>
            {/* Neula */}
            <path className="gauge-needle" d={pathData} />

            {/* Keskus */}
            {/*<circle cx="100" cy="100" r="8" fill="#222" />*/}
            <polygon
                points="100,97 103,100 100,103 97,100"
                fill="#222"
            />
            


            <text
                x="100"
                y="120"
                textAnchor="middle"
                fontSize="20"
                fontWeight="bold"
                fill="#222"
                >
                {value.toFixed(2)}°
            </text>            
            </>
        )}

        { !showNeedle && (
            <text
                x="100"
                y="120"
                textAnchor="middle"
                fontSize="24"
                fontWeight="bold"
                fill="#222"
                >
                OVERLIMIT
            </text>
        )}

      </svg>
      {/*<div className="gauge-value">{showNeedle && clamped.toFixed(1)}°</div>*/}
    </div>
  );
};

export default ModernGauge;
